import * as yup from 'yup';

import { usePreviousInsuranceStore } from '@/features/PreviousInsurance/store';

export const previousInsuranceSchema = yup.object({
  gesellschaft: yup
    .string()
    .default('')
    .when({
      is: () => usePreviousInsuranceStore().hasPreviousInsurance,
      then: yup.string().required(),
    }),
  versicherungsnummer: yup
    .string()
    .default('')
    .when({
      is: () => usePreviousInsuranceStore().hasPreviousInsurance,
      then: yup.string().required(),
    }),
  kuendigender: yup.string().default(''),
  kuendigen: yup.bool().default(false),
  gekuendigt: yup.bool().default(false),
  beginn: yup
    .date()
    .nullable()
    .default(null)
    .when({
      is: () => usePreviousInsuranceStore().hasPreviousInsurance,
      then: yup.date().required(),
    }),
  ablauf: yup
    .date()
    .nullable()
    .default(null)
    .when({
      is: () => usePreviousInsuranceStore().hasPreviousInsurance,
      then: yup.date().required(),
    }),
});

export const sharedContractBaseSchema = yup.object({
  zahlart: yup.string().default(''),
});

export type PreviousInsurance = yup.Asserts<typeof previousInsuranceSchema>;
